import { useQuery, gql } from "@apollo/client"
import { Button, Modal, Text } from "@oysterhr/ui"
import { idToStrongId } from "@oysterhr/common"
import { companyPaymentMethodsPath } from "@oysterhr/payments"
import { useTranslation, Trans } from "react-i18next"
import { Engagement } from "@oysterhr/schema"
import { Link } from "react-router-dom"

type EnforcementModalAfterHireProps = {
  setShowModal: (isOpen: boolean) => void
  companyId: string
  engagementId?: string
}

const EngagementQuery = gql`
  query DirectDebitEnforcementModalEngagement($engagementId: ID!) {
    engagement(engagementId: $engagementId) {
      id
      teamMemberName
    }
  }
`

export const EnforcementModalAfterHire = ({
  setShowModal,
  companyId,
  engagementId,
}: EnforcementModalAfterHireProps) => {
  const { t } = useTranslation("DirectDebitGuard")
  const strongId = idToStrongId(engagementId || "")
  const engagementIdAPI = strongId && `Employment:${strongId}`
  const { data } = useQuery<{ engagement: Engagement }>(EngagementQuery, {
    skip: !engagementIdAPI,
    variables: {
      engagementId: engagementIdAPI,
    },
  })

  const teamMemberName = data?.engagement?.teamMemberName

  return (
    <Modal
      isOpen={true}
      onRequestClose={() => {
        setShowModal(false)
      }}
    >
      <Modal.Header align="center" icon="WarningTriangle" iconVariation="warning">
        {t("enforcementModalAfterHire.title")}
      </Modal.Header>
      <Modal.Content className="space-y-6">
        <Text>{t("enforcementModalAfterHire.body")}</Text>
        <Text>
          <Trans
            defaults={t("enforcementModalAfterHire.body2", {
              teamMemberName,
            })}
            components={{
              semibold: <span className="font-semibold" />,
            }}
          />
        </Text>
      </Modal.Content>
      <Modal.Footer className="mt-0 flex justify-end">
        <Button as={Link} to={companyPaymentMethodsPath(companyId)}>
          {t("enforcementModalAfterHire.primaryButtonLabel")}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
